import service from '@/api/index.js'

export const loginChannel = function (params) {
  return service({
    url: '/loginApi/loginChannel',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const getCaptcha = function (params) {
  return service({
    url: '/loginApi/getVerifyCode',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const login = function (params) {
  return service({
    url: '/loginApi/loginWebSms',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const getRewardList = function (params) {
  return service({
    url: '/rewardWebApi/reward',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const reserve = function (params) {
  return service({
    url: '/rewardWebApi/inviteAction',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const inviteCode = function (params) {
  return service({
    url: '/rewardWebApi/getInvite',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const getReward = function (params) {
  return service({
    url: '/rewardWebApi/getReward',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export const sendCode = function (params) {
  return service({
    url: '/rewardApi/getCode',
    method: 'get',
    params: params,
  })
}

export const getUserList = function (params) {
  return service({
    url: '/loginApi/getUserList',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}




export const getHomeData = function (params) {
  return service({
    baseURL: process.env.VUE_APP_API2,
    url: '/config',
    method: 'post',
    data: params,
  })
}

export const getNewsData = function (params, type) {
  return service({
    baseURL: process.env.VUE_APP_API2,
    url: '/news/' + type,
    method: 'get',
    params: params,
  })
}

export const getNewsDetail = function (params, id) {
  return service({
    baseURL: process.env.VUE_APP_API2,
    url: '/detail/' + id,
    method: 'get',
    params: params,
  })
}




export const getNewsList = function (params) {
  return service({
    url: '/newsList',
    method: 'get',
    params: params,
  })
}

export const getGiftData = function (params) {
  return service({
    url: '/giftData',
    method: 'get',
    params: params,
  })
}